import React from 'react';
import { useStaticQuery } from 'gatsby';
import NewMenuStructure from '@interness/web-core/src/components/structure/MenuStructure/NewMenuStructure';
import MenuStructure from '@interness/web-core/src/components/structure/MenuStructure/MenuStructure';
import { findT } from '@interness/web-core/src/components/_helpers';
import * as S from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
const PrimaryNav = () => {
  const data = useStaticQuery(query);
  const menu = data.directusMenus ? findT(data.directusMenus.translations, 'de').config : null;
  const menuNew = data.directusMenusNew ? data.directusMenusNew.config : null;
  return ___EmotionJSX(S.Sidebar, null, menuNew ? ___EmotionJSX(NewMenuStructure, {
    menu: menuNew
  }) : ___EmotionJSX(MenuStructure, {
    menu: menu
  }));
};
const query = "169925597";
export default PrimaryNav;